import {
    GetUserVerification,
    SuccessIdentityVerification,
    SuccessVerification,
    UpdatePaymentSystemVerification,
    VerificationActions,
    VerificationSubmitActions,
} from '../actions/verification.actions';
import { IdentityVerificationStatus } from '../models/verifications.model';
import { UserVerificationState } from '../state/verification.state';

export const initialUserVerificationState: UserVerificationState = {
    identityVerification: IdentityVerificationStatus.NOT_FOUND,
    psVerification: { verified: [], notVerified: [] },
    paymentSystemSafetiness: false,
    userId: undefined,
    merchant: undefined,
};

export function userVerificationReducer(
    state = initialUserVerificationState,
    action: VerificationSubmitActions
): UserVerificationState {
    switch (action.type) {
        case VerificationActions.successVerification:
            const successAction = action as SuccessVerification;
            return {
                ...state,
                ...successAction.payload,
            };

        case VerificationActions.successIdentityVerification:
            const success = action as SuccessIdentityVerification;
            return {
                ...state,
                identityVerification: success.payload.identityVerification,
            };

        case VerificationActions.failVerification:
            return {
                ...state,
                identityVerification: IdentityVerificationStatus.NOT_FOUND,
            };

        case VerificationActions.clearVerification:
            return {
                ...initialUserVerificationState,
            };

        default:
            return state;
    }
}
